import { Button } from '@mui/material'
import { CarrierVisitDto } from '@operations/app/api'
import { useTranslate } from '@tolgee/react'
import { Header } from '@tom-ui/ui'
import { PATHS } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import { Breadcrumbs, BreadcrumpItem } from 'modules/ui/src/theme/components/breadcrumbs/Breadcrumb'
import { useMemo } from 'react'
import { useNavigate } from 'react-router'

interface Props {
  stoppageId: number
  formId: string
  visit?: CarrierVisitDto
}
export const StoppageFormHeader = observer(({ visit, stoppageId, formId }: Props) => {
  const navigate = useNavigate()
  const { t } = useTranslate()

  const action = stoppageId ? t('edit', 'Edit') : t('record', 'Record')

  const breadCrumbs: BreadcrumpItem[] = useMemo(() => {
    return [
      {
        label: visit?.carrierName ?? t('vesselVisit', 'Vessel visit'),
        onClick: () => navigate(`${PATHS.visits.vesselVisits.url}/${visit?.id}/dashboard`),
      },
      {
        label: t(PATHS.visits.vesselVisits.stoppages.title),
        onClick: () =>
          navigate(
            `${PATHS.visits.vesselVisits.url}/${visit?.id}/${PATHS.visits.vesselVisits.stoppages.url}`,
          ),
      },
      {
        label: action,
      },
    ]
  }, [visit?.carrierName, visit?.id, t, action, navigate])

  return (
    <>
      <Breadcrumbs items={breadCrumbs} />
      <Header
        title={t('upsertStoppage', '{action} stoppage', {
          action: action,
        })}
        position='relative'
        rightRenderOption={
          <>
            <Button
              variant='text'
              color='inherit'
              data-cy='cancel-stoppage-btn'
              onClick={() =>
                navigate(
                  `${PATHS.visits.vesselVisits.url}/${visit?.id}/${PATHS.visits.vesselVisits.stoppages.url}`,
                )
              }
            >
              {t('cancel', 'Cancel')}
            </Button>
            <Button
              variant='contained'
              color='primary'
              type='submit'
              form={formId}
              data-cy='stoppage-save-btn'
            >
              {t('submit', 'Submit')}
            </Button>
          </>
        }
      />
    </>
  )
})
